module.exports = __webpack_public_path__ + "static/pattern-checker.a86bd2ca.svg";